import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CAMPAIGN_CONFIGURATION, GET_CAMPAIGN_CONFIGURATION_SUCCESS, GET_CAMPAIGN_CONFIGURATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCampaignConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    // const { membershipId, benefitConfigId,page_size, page_index } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/campaigns/campaigns-configuration`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_CAMPAIGN_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CAMPAIGN_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CAMPAIGN_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchGetCampaignConfiguration() {
  yield takeEvery(GET_CAMPAIGN_CONFIGURATION, getCampaignConfiguration);
}

function* getCampaignConfigurationSaga() {
  yield all([fork(watchGetCampaignConfiguration)]);
}

export default getCampaignConfigurationSaga;
